const STAGE_LABELS: Record<string, string> = {
  '00_input': 'Input',
  '00b_background_analysis': 'Background analysis',
  '00c_background_cleanup': 'Background cleanup',
  '01_cutout': 'Cutout',
  '01b_exposure': 'Exposure',
  '02_stabilized': 'Stabilized',
};

export function stageLabel(stage: string): string {
  return STAGE_LABELS[stage] ?? stage;
}
